import React, { useState } from 'react';
import './App.css';
import TheMarket from './Components/TheMarket/TheMarket';
import TheBasket from './Components/TheBasket/TheBasket';
import LoginPage from './Components/TheLogin/LoginPage';
import CatalogueUpdateScreen from './Components/TheAdmin/CatalogueUpdateScreen';
import AppLayout from './Components/AppLayout';
import CatalogueUpdateLayout from './Components/CatalogueUpdateLayout';
import { BasketProvider } from './BasketContext';
import './Components/TheFonts/fonts.css';
import { Link, Route, Routes, HashRouter as Router, useLocation, useNavigate } from 'react-router-dom';

function App() {
  return (
    <BasketProvider>
      <Router>
        <div className="App" >
          <ConditionalMainMenu />
          <Routes>
            <Route path="/" element={<AppLayout />}>
              <Route index element={<TheMarket />} />
            </Route>
            <Route path="/LoginPage" element={<LoginPage />} />
            <Route path="/catalogue-update" element={<CatalogueUpdateLayout />}>
              <Route index element={<CatalogueUpdateScreen />} />
            </Route>
          </Routes>
        </div>
      </Router>
    </BasketProvider>
  );
}

function ConditionalMainMenu() {
  const location = useLocation();
  if (location.pathname === '/LoginPage') {
    return null;
  }
  return <MainMenu />;
}

function MainMenu() {
  const location = useLocation();
  const navigate = useNavigate();
  const pageTitle = getPageTitle(location.pathname);

  const [isModalOpen, setModalOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const openLoginModal = () => {
    setShowLoginModal(true);
  };

  const closeLoginModal = () => {
    setShowLoginModal(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/');
  };

  return (
    <div className="mainMenu">
      <p className="title MainTitle">Composure</p>
      <p className="pageTitle">{pageTitle}</p>
      <div className="right-content">
        <Link to="/" className="pill-link">🏠 Home</Link>
        <b><Link to="/catalogue-update" className="pill-link">⚙️ Maintain Shop</Link></b>
        {localStorage.getItem('token') ? (
          <span className="pill-link" onClick={handleLogout} style={{ cursor: 'pointer' }}>🚪 Logout</span>
        ) : (
          <span className="pill-link" onClick={openLoginModal} style={{ cursor: 'pointer' }}>🔐 Login</span>
        )}
        {localStorage.getItem('token') && <span className="pill-link" onClick={openModal} style={{ cursor: 'pointer' }}>🛒 Cart</span>}
        <BasketProvider>
          <TheBasket isOpen={isModalOpen} onClose={closeModal} />
        </BasketProvider>
        {showLoginModal && <LoginPage onClose={closeLoginModal} />}
      </div>
    </div>
  );
}

function getPageTitle(pathname) {
  switch (pathname) {
    case '/':
      return 'Home';
    case '/LoginPage':
      return 'Login';
    case '/catalogue-update':
      return 'Update Catalogue';
    default:
      return '';
  }
}

export default App;